/**
 * 博客频道
 */
var ad = require('../modules/ad/ad');
var tools = require('tools');

var pager = (function () {
    function page(options) {
        var defaultoptions = {
            sum : 0, //总数
            pagecount : 0, //每页多少条
            thispage : 0, //当前页
            linkaddress : '{page}.html', //链接地址
            needlast : true, //是否需要尾页
            needsum : true, //是否需要总共多少页
            firstpage_hide_first : false, //第一页隐藏首页
            pagertype : '', //分页种类
            linkbind : function (thislink) { //链接回调
                
            }
        }
        this.options = $.extend(defaultoptions, options);
    }

    page.prototype.getPagerElems = function () { //返回分页jquerydom
        var _this = this;
        var sumcount = parseInt(this.options.sum);
        var pagecount = parseInt(this.options.pagecount);
        var thispage = parseInt(this.options.thispage);
        if( sumcount < pagecount ){
            return null;
        }
        var sumpage = Math.ceil(sumcount / pagecount); //总页数
        var temphtml = [];
        temphtml.push('<div id="page_index" class="page_index">[<span class="font_red">' + thispage + '</span>/' + sumpage + ']</div>');

        temphtml.push('<div id="page_box" class="page">');
        if( thispage == 1 ){
            temphtml.push('<span class="pre">上一页</span>');
        }
        else{
            temphtml.push('<span class="pre"><a href="' + this.getpagelink(thispage - 1) + '">上一页</a></span>');
        }
        
        if( thispage < sumpage ){
            temphtml.push('<span class="btn next"><a href="' + this.getpagelink(thispage + 1) + '">下一页</a></span>');
        }
        else{
            temphtml.push('<span class="btn next">下一页</span>');
        }

        temphtml.push('</div>');

        return temphtml.join('');
    };

    page.prototype.getpagelink = function (pageindex){
        return this.options.linkaddress.replace(/{page}/, pageindex);
    };

    return page;
})();

if ( typeof userpager != "undefined" ) {
    var newuserpager = new pager({
        sum : userpager.sum,
        pagecount : userpager.pagesize,
        thispage : userpager.thispage,
        linkaddress : '?page={page}'
    });
    $('#userpagerdiv').html(newuserpager.getPagerElems());
}

if ( tools.getQueryString("coop_s") != "hejubao" ) {
	var topad = new ad({
		source : 'http://cp.eastmoney.com/wap/37.js',
		type : 'pagetop'
	});
	topad.show();

	var bottomad = new ad({
		source : 'http://cp.eastmoney.com/wap/91.js',
		type : 'pagebuttom_fix'
	});	
	bottomad.show();
}



//////////////////
// WEBPACK FOOTER
// ./dev/channel/blog.js
// module id = 0
// module chunks = 0